<div class="external-links-container">
  @if (label()) {
    <p class="external-links-label">{{ label() }}</p>
  }

  @for (link of links; track $index) {
    <div class="external-link-row">
      <input
        type="url"
        class="external-link-input"
        [placeholder]="placeholder()"
        [value]="link"
        (input)="onLinkChange($index, $any($event.target).value)"
      />
      <button
        type="button"
        class="remove-link-btn"
        (click)="removeLink($index)"
        title="Remove link"
      >&times;</button>
    </div>
  }

  @if (submitted() && required() && !hasValidLinks()) {
    <div class="field-error">
      {{ 'common.externalLinks.validationRequired' | translate }}
    </div>
  }
  @if (hasInvalidUrls()) {
    <div class="field-error">
      {{ 'common.externalLinks.validationUrl' | translate }}
    </div>
  }

  <button type="button" class="add-link-btn" (click)="addLink()">
    + {{ 'common.externalLinks.addLink' | translate }}
  </button>
</div>
